import type { ShapeSitePurchase } from "@aprao/model/src/shapes/ShapeSitePurchase.js";

export const buildSitePurchaseDescription = (
  site: ShapeSitePurchase,
  sites: Array<ShapeSitePurchase>,
) =>
  site.description.length === 0 ?
    `Site ${sites.indexOf(site) + 1}`
  : site.description;
